'use client'

import Reveal from '../Reveal'

const steps = [
  {
    n: '01',
    title: 'Pledge collateral',
    body: 'Deposit BTC, ETH or any of 50+ supported assets into an insured, segregated vault. You always retain ownership.',
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v18m0 0c-3.5 0-6-1.5-6-3.5M12 21c3.5 0 6-1.5 6-3.5M6 7.5C6 9.5 8.5 11 12 11s6-1.5 6-3.5S15.5 4 12 4 6 5.5 6 7.5z" />
    ),
  },
  {
    n: '02',
    title: 'Choose your terms',
    body: 'Pick your loan amount up to your available LTV, set a flexible repayment plan, and lock a rate from 0.9% APR.',
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 7h6m-6 4h6m-6 4h4M5 4h14a1 1 0 011 1v14a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1z" />
    ),
  },
  {
    n: '03',
    title: 'Get funded fast',
    body: 'Receive stablecoins or fiat to your wallet or bank — typically in under two minutes. No credit checks, ever.',
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
    ),
  },
  {
    n: '04',
    title: 'Repay & reclaim',
    body: 'Repay anytime with zero prepayment penalties. Your collateral is instantly returned — plus any gains it made.',
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
    ),
  },
]

export default function HowItWorks() {
  return (
    <section id="how" className="relative py-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-xs tracking-[0.3em] text-electric-400 uppercase mb-3">
            Simple by design
          </p>
          <h2 className="font-display font-bold text-3xl sm:text-4xl text-chrome">
            Liquidity in four steps
          </h2>
          <p className="mt-4 text-steel-300">
            No selling. No taxable events. No paperwork. Just credit against the
            crypto you already hold.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1}>
              <div className="relative glass glass-hover rounded-2xl p-7 h-full">
                <span className="absolute top-6 right-6 font-display font-bold text-5xl text-steel-700/60">
                  {s.n}
                </span>
                <div className="w-12 h-12 rounded-xl bg-electric-500/10 ring-1 ring-electric-500/30 flex items-center justify-center mb-5 shadow-glow-sm">
                  <svg className="w-6 h-6 text-electric-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6}>
                    {s.icon}
                  </svg>
                </div>
                <h3 className="font-semibold text-white text-lg mb-2">{s.title}</h3>
                <p className="text-sm text-steel-300 leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
